import { render, staticRenderFns } from "./MoreContent.vue?vue&type=template&id=6b680c4f&scoped=true&"
import script from "./MoreContent.vue?vue&type=script&lang=js&"
export * from "./MoreContent.vue?vue&type=script&lang=js&"
import style0 from "./MoreContent.vue?vue&type=style&index=0&id=6b680c4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b680c4f",
  null
  
)

export default component.exports